import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const show = async (portalModule) => {
  return await dponetAPI.get(`/company_guest_portal_configs/${portalModule}`)
}

const create = async (data) => {
  return await dponetAPI.post('/company_guest_portal_configs', {
    companyGuestPortalConfig: data,
  })
}

const update = async (portalModule, data) => {
  return await dponetAPI.put(`/company_guest_portal_configs/${portalModule}`, {
    companyGuestPortalConfig: data,
  })
}

const regenerateToken = async (portalModule) => {
  return await dponetAPI.put(
    `/company_guest_portal_configs/${portalModule}/regenerate_token`,
  )
}

export default { show, create, update, regenerateToken }
